import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { createAction } from 'redux-actions';
import { StreamType } from '../types';
import { actionKey } from './constants';
export const STREAM__WITH_OFFSET__INITIALIZE = `${actionKey}__INITIALIZE`;
export const STREAM__WITH_OFFSET__FETCH = `${actionKey}__FETCH`;
export const STREAM__WITH_OFFSET__FETCH_SUCCESS = `${actionKey}__FETCH_SUCCESS`;
export const STREAM__WITH_OFFSET__FETCH_FAILURE = `${actionKey}__FETCH_FAILURE`;
export const STREAM__WITH_OFFSET__INSERT_ITEMS = `${actionKey}__INSERT_ITEMS`;
export const STREAM__WITH_OFFSET__FETCH_SUCCESS_DEDUPE = `${actionKey}__FETCH_SUCCESS_DEDUPE`;
export const initialize = (_param)=>{
    var { nextOffset, prevOffset } = _param, baseInitializeParams = _object_without_properties(_param, [
        "nextOffset",
        "prevOffset"
    ]);
    return _object_spread_props(_object_spread({}, baseInitializeParams), {
        type: STREAM__WITH_OFFSET__INITIALIZE,
        streamType: StreamType.WITH_OFFSET,
        nextOffset,
        prevOffset
    });
};
export const fetch = (streamId)=>({
        type: STREAM__WITH_OFFSET__FETCH,
        streamId
    });
export const fetchAll = (streamId)=>({
        type: STREAM__WITH_OFFSET__FETCH,
        streamId,
        all: true
    });
export const fetchSuccess = (payload)=>_object_spread({
        type: STREAM__WITH_OFFSET__FETCH_SUCCESS
    }, payload);
export const fetchSuccessDeduped = (payload)=>_object_spread({
        type: STREAM__WITH_OFFSET__FETCH_SUCCESS_DEDUPE
    }, payload);
export const insertItems = ({ streamId, items, offset, entities, doNotUpdateNextOffset })=>({
        type: STREAM__WITH_OFFSET__INSERT_ITEMS,
        streamId,
        items,
        offset,
        entities,
        doNotUpdateNextOffset
    });
export const fetchPrevious = createAction(`${actionKey}__FETCH_PREVIOUS`, (streamId)=>({
        streamId
    }));
export const fetchPreviousSuccess = createAction(`${actionKey}__FETCH_PREVIOUS_SUCCESS`, ({ streamId, items, entities, hasLess, prevOffset, dedupeFunction })=>({
        streamId,
        items,
        entities,
        hasLess,
        prevOffset,
        dedupeFunction
    }));
export const fetchAllSuccess = createAction(`${actionKey}__FETCH_ALL_SUCCESS`, ({ streamId, items, entities })=>({
        streamId,
        items,
        entities
    }));
export const emptyStream = createAction(`${actionKey}__EMPTY`, (streamId)=>({
        streamId
    }));
export const resetStream = createAction(`${actionKey}__RESET`, (streamId)=>({
        streamId
    }));
export * from '../base/actions';
